<un-page [backgroundColor]="isLoading ? 'white' : 'transparent'">
  <un-top-bar slot="header">
    <un-usp-link [url]="aboutUrl" icon="price-tag">Geen winstoogmerk</un-usp-link>
    <un-usp-link [url]="customerAppreciationUrl" icon="user-group">Meer dan 1,6 miljoen trouwe leden</un-usp-link>
    <un-usp-link [url]="storesUrl" icon="map-location">Altijd in de buurt met 100 winkels</un-usp-link>
  </un-top-bar>

  <un-header
    [logoUrl]="websiteUrl"
    [navigationItems]="navigationItems"
    brand="Univé"
    logo="assets/images/logo-unive.svg"
    slot="header"
  >
    <un-button (click)="onAppointment()" slot="actions">Maak een afspraak</un-button>
  </un-header>

  @if (isLoading) {
    <un-page-loader>We berekenen nu wat u nodig heeft...</un-page-loader>
  }
  @if (!isLoading) {
    <router-outlet></router-outlet>
  }

  <un-footer logo="assets/logos/unive-payoff.svg" logoDescription="Univé Logo Payoff" slot="footer">
    <un-social-link (click)="onSocial('facebook')" [url]="facebookLink" icon="facebook"></un-social-link>
    <un-social-link (click)="onSocial('x')" [url]="xLink" icon="x"></un-social-link>
    <un-social-link (click)="onSocial('instagram')" [url]="instagramLink" icon="instagram"></un-social-link>
    <un-social-link (click)="onSocial('linkedin')" [url]="linkedInLink" icon="linkedin"></un-social-link>
    <un-social-link (click)="onSocial('youtube')" [url]="youtubeLink" icon="youtube"></un-social-link>

    <un-footer-link (click)="onInfo('Kwetsbaarheid melden')" [url]="reportVulnerabilityLink">
      Kwetsbaarheid melden
    </un-footer-link>
    <un-footer-link (click)="onInfo('Disclaimer')" [url]="disclaimerLink">Disclaimer</un-footer-link>
    <un-footer-link (click)="onInfo('Privacy')" [url]="privacyLink">Privacy</un-footer-link>
  </un-footer>
</un-page>
